<div>
  <app-common-search-view [form]="form" header="Närvaro på institutionsnivå/månad" [showSpinner]="showSpinner" [districts]="true" (createReport)="createReport($event)" (clearReportView)="clearReport()" [multiple]="false" [singleyear]=true>
  </app-common-search-view>
</div>
<br>
<div *ngIf="result.length > 0" class="col-md-12">
  <p *ngIf="form.get('selectedFilter').value < 3">Läser in {{antalInst}} av {{antal}} &nbsp;<p-progressSpinner strokeWidth="8" [style]="{width: '20px', height: '20px'}" *ngIf="form.get('selectedFilter').value !== 2 && antalInst !== antal"></p-progressSpinner>
  </p>
</div>
<div *ngIf="result?.length > 0" class="ms-4 me-4">
  <p-menubar [model]="items">
    <div style="margin-top:5px;margin-right:10px;">
      <span *ngIf="form.get('selectedFilter').value < 3">Resultat: {{antalInst?.length}}</span>
      <span *ngIf="form.get('selectedFilter').value > 2">Resultat: {{result?.length}}</span>
    </div>
  </p-menubar>
  <table class="table">
    <tr>
      <th>Rad</th>
      <th>Insttyp</th>
      <th>Nr</th>
      <th>Namn</th>
      <th>Distrikt</th>
      <th>Mötestyp</th>
      <th>År</th>
      <th>Månad</th>
      <th>Antal möten</th>
      <th>Antal egnas besök i annan inst.</th>
      <th>Antal gäster från annan inst.</th>
      <th>Egna närvarande</th>
      <th>Antal medlemmar i logen vid årets slut</th>
    </tr>
    <tr *ngFor="let r of result;index as i;">
      <td>{{i + 1}}</td>
      <td>{{r?.institutionType}}</td>
      <td>{{r?.nr}}</td>
      <td>{{r?.name}}</td>
      <td>{{r?.district}}</td>
      <td>{{r?.meetingType}}</td>
      <td>{{r?.year}}</td>
      <td>{{r?.month}}</td>
      <td>{{r?.numberOfMeetings}}</td>
      <td>{{r?.numberOfOwnMembersInOtherInstitutions}}</td>
      <td>{{r?.numberOfGuestsFromOtherInstitutions}}</td>
      <td>{{r?.attendance}}</td>
      <td>{{r?.membersAtEndOfYear}}</td>
    </tr>
  </table>
</div>